import { createEntityAdapter } from '@reduxjs/toolkit';
import ICompanyManager from 'types/company/managers/ICompanyManager';

const managersAdapter = createEntityAdapter<ICompanyManager>({
  selectId: manager => manager.id,
});

export default managersAdapter;
